import { ListItemButton, ListItemText, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

interface IProps {
  Icon: React.ElementType;
  isActive?: boolean;
  disabled?: boolean;
  label: string;
  href?: string;
  count?: number;
  onClick?: () => void;
}
export const LinkDrawer: React.FC<IProps> = ({
  Icon,
  isActive,
  disabled,
  label,
  href,
  count,
  onClick,
}) => {
  const navigate = useNavigate();

  return (
    <ListItemButton
      disabled={disabled}
      autoFocus={isActive}
      onClick={() => {
        onClick && onClick();
        href && navigate(href);
      }}
      sx={{
        height: '48px',
        padding: '0 12px',
        gap: '12px',
        backgroundColor: isActive ? 'background.brandLight' : '',
        color: 'text.primary',
        fontWeight: isActive ? 500 : 400,
        borderRadius: '4px',
        '&:hover': {
          backgroundColor: isActive
            ? 'background.brandLight'
            : 'highlight.neutral',
        },
        ...(isActive && {
          '&.Mui-focusVisible': { backgroundColor: 'background.brandLight' },
        }),
      }}
    >
      {Icon && (
        <Icon
          sx={{
            fontSize: '20px',
            color: isActive ? 'text.brand' : 'text.secondary',
          }}
        />
      )}
      <ListItemText
        primary={label}
        primaryTypographyProps={{ fontWeight: 'inherit' }}
        sx={{ margin: 0, fontWeight: 'inherit' }}
      />
      {count !== undefined && (
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{
            lineHeight: 1.4,
            fontWeight: 'inherit',
            fontVariantNumeric: 'tabular-nums',
          }}
        >
          {count}
        </Typography>
      )}
    </ListItemButton>
  );
};
